import React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
/**
 * @typedef {import('../../App.d.ts').ComponentDependenciesTableProps} ComponentDependenciesTableProps
 * @typedef {import('../../App.d.ts').DefaultTableMapperInterface} DefaultTableMapperInterface
 * @typedef {import('../../App.d.ts').Dependency} Dependency
 */
/**
 *
 * @param {Dependency[]} dependencies
 * @returns {Dependency[]}
 */

const processDependencies = (dependencies) => dependencies
  .filter((d, pos) => dependencies.findIndex((id) => id.name === d.name) === pos)
  .sort((a, b) => a.name.localeCompare(b.name));

/**
 *
 * @param {DefaultTableMapperInterface} fields
 * @returns {Element}
 * @constructor
 */
export default (fields) => {
  const deps = processDependencies(fields.dependencies);

  return (
    <Container>
      {fields.area && <h5>{fields.area}</h5>}
      <Container multiColumn>
        <ul>
          {deps.map((d) => (
            <li key={d.name}>
              <span>{d.name}</span>{' '}
              <span>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={d.licenseURL}
                >
                  {d.licenseName}
                </a>
              </span>
            </li>
          ))}
        </ul>
      </Container>
    </Container>
  );
};
